<template src="./template.html"></template>
<script>
  import {form} from 'lvgs-vue-modules';

  export default form.text;
</script>